import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import FormatUtils from '../common/formatUtils/FormatUtils';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import { setError } from '../common/toast/toast';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import SelectDefault from '../common/form/selectDefault';
import DateFormat from '../common/dateFormat/DateFormat';
import ColorUtils from '../common/colorUtils/ColorUtils';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import consts from '../consts';

import {
	setModoTela, initForm
} from './controleRouteIdActions';

class ControleRouteIdForm extends Component {

	state = {

	}

	render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

		return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							<Field
								name='codigo'
								component={LabelAndInput}
								label='Código' placeholder='Informe o código'
								cols='12 12 8 6'
								readOnly={readOnly} />
						</Row>
						<Row>
							<Field
								name='id_tabela_frete_vigencia'
								component={LabelAndInput}
								label='ID Vigência' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />

							<Field
								name='id_tabela_frete_rota'
								component={LabelAndInput}
								label='ID Tabela Frete' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />

							<Field
								name='id_rota'
								component={LabelAndInput}
								label='ID Rota' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />

							<Field
								name='servico'
								component={LabelAndInput}
								label='Serviço' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />
								
							<Field
								name='tipo_veiculo'
								component={LabelAndInput}
								label='Tipo de Veículo' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />

							<Field
								name='nome_natureza'
								component={LabelAndInput}
								label='Natureza' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'} />

							<LabelAndInputDate
								label='Início de Vigência' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'}
								value={this.props.formularioValues.data_inicio_vigencia} />
								
							<LabelAndInputDate
								label='Fim de Vigência' placeholder='Informe'
								cols='12 6 4 3'
								readOnly={'readOnly'}
								value={this.props.formularioValues.data_fim_vigencia} />

						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
									<Button
										text='Salvar'
										submit
										type={'success'}
										icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</ContentCard>
		);
	}

}

ControleRouteIdForm = reduxForm({ form: 'controleRouteIdForm', destroyOnUnmount: false })(ControleRouteIdForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	formularioValues: getFormValues('controleRouteIdForm')(state),
	registro: state.controleRouteId.registro,
	listaSetor: state.setor.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ControleRouteIdForm);